// @flow
/* @toast-service */
import Vue from 'vue'

/**
 * ToastService typename
 * @private
 * @memberof ToastService
 */

type Options = {|
  text?: string,
  remove?: number
|}

const success = (header: string, options?: Options) => {
  return Vue.$toast({
    type: 'success',
    header: header,
    remove: 2000,
    ...options
  })
}

const warning = (header: string, options?: Options) => {
  return Vue.$toast({
    type: 'warning',
    header: header,
    remove: 10000,
    ...options
  })
}

const error = (header: string, options?: Options) => {
  return Vue.$toast({
    type: 'error',
    header: header,
    remove: 5000,
    ...options
  })
}

const remove = (toastId: string) => Vue.$removeToast(toastId)

const self = {
  success,
  warning,
  error,
  remove
}

/**
 *
 * @module ToastService
 * @namespace ToastService
 * @version 1.0.0
 */
export default self
